package features.booking

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Email
import androidx.compose.material.icons.filled.People
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Phone
import androidx.compose.material.icons.filled.Receipt
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp

@Composable
fun SolicitudesFacturaView(viewModel: AdminViewModel) {
    val solicitudes by viewModel.solicitudesFactura.collectAsState()
    val isLoading by viewModel.isLoading.collectAsState()
    val correoContador by viewModel.correoContador.collectAsState()
    val correoCopia by viewModel.correoCopia.collectAsState()
    var editandoCorreos by remember { mutableStateOf(false) }
    var correoContadorTemp by remember { mutableStateOf("") }
    var correoCopiaTemp by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        viewModel.cargarSolicitudesFactura()
        viewModel.cargarCorreoContador()
    }

    Column(modifier = Modifier.fillMaxSize()) {
        Text(
            "Solicitudes de Factura",
            style = MaterialTheme.typography.headlineSmall,
            fontWeight = FontWeight.Black,
            color = SmartVanColors.AzulOscuro
        )
        Text(
            "Revisa los datos fiscales y envialos a tu contador con un clic.",
            style = MaterialTheme.typography.bodySmall,
            color = Color.Gray,
            modifier = Modifier.padding(top = 4.dp, bottom = 12.dp)
        )

        // Configurar correos
        Card(
            colors = CardDefaults.cardColors(containerColor = Color(0xFFF3E5F5)),
            shape = RoundedCornerShape(12.dp),
            modifier = Modifier.fillMaxWidth().padding(bottom = 16.dp)
        ) {
            Column(modifier = Modifier.padding(14.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Filled.Email, contentDescription = null, tint = Color(0xFF7B1FA2), modifier = Modifier.size(18.dp))
                    Spacer(modifier = Modifier.width(8.dp))
                    Text("Correos para Facturas", fontWeight = FontWeight.Bold, color = Color(0xFF7B1FA2), style = MaterialTheme.typography.bodyMedium)
                }
                Spacer(modifier = Modifier.height(6.dp))
                if (editandoCorreos) {
                    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        OutlinedTextField(
                            value = correoContadorTemp,
                            onValueChange = { correoContadorTemp = it },
                            label = { Text("Correo del Contador (destinatario principal)") },
                            placeholder = { Text("contador@ejemplo.com") },
                            leadingIcon = { Icon(Icons.Filled.Person, contentDescription = null, tint = Color(0xFF7B1FA2), modifier = Modifier.size(16.dp)) },
                            modifier = Modifier.fillMaxWidth(),
                            singleLine = true,
                            shape = RoundedCornerShape(8.dp),
                            textStyle = MaterialTheme.typography.bodySmall
                        )
                        OutlinedTextField(
                            value = correoCopiaTemp,
                            onValueChange = { correoCopiaTemp = it },
                            label = { Text("Correo en copia (CC) para seguimiento") },
                            placeholder = { Text("admin@ejemplo.com") },
                            leadingIcon = { Icon(Icons.Filled.People, contentDescription = null, tint = Color(0xFF9C27B0), modifier = Modifier.size(16.dp)) },
                            modifier = Modifier.fillMaxWidth(),
                            singleLine = true,
                            shape = RoundedCornerShape(8.dp),
                            textStyle = MaterialTheme.typography.bodySmall,
                            supportingText = { Text("Este correo recibira copia de cada solicitud enviada al contador", style = MaterialTheme.typography.labelSmall, color = Color.Gray) }
                        )
                        Button(
                            onClick = {
                                viewModel.guardarCorreoContador(correoContadorTemp.trim())
                                viewModel.guardarCorreoCopia(correoCopiaTemp.trim())
                                editandoCorreos = false
                            },
                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF7B1FA2)),
                            shape = RoundedCornerShape(8.dp),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text("Guardar Correos", style = MaterialTheme.typography.labelSmall, color = Color.White, fontWeight = FontWeight.Bold)
                        }
                    }
                } else {
                    Column(modifier = Modifier.clickable {
                        correoContadorTemp = correoContador
                        correoCopiaTemp = correoCopia
                        editandoCorreos = true
                    }) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Icon(Icons.Filled.Person, contentDescription = null, tint = Color(0xFF7B1FA2), modifier = Modifier.size(14.dp))
                            Spacer(modifier = Modifier.width(6.dp))
                            Text("Contador: ", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                            Text(
                                if (correoContador.isBlank()) "Sin configurar" else correoContador,
                                style = MaterialTheme.typography.bodySmall,
                                color = if (correoContador.isBlank()) Color.Gray else Color(0xFF4A148C),
                                fontWeight = if (correoContador.isNotBlank()) FontWeight.Bold else FontWeight.Normal
                            )
                        }
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Icon(Icons.Filled.People, contentDescription = null, tint = Color(0xFF9C27B0), modifier = Modifier.size(14.dp))
                            Spacer(modifier = Modifier.width(6.dp))
                            Text("Copia (CC): ", style = MaterialTheme.typography.labelSmall, color = Color.Gray)
                            Text(
                                if (correoCopia.isBlank()) "Sin configurar" else correoCopia,
                                style = MaterialTheme.typography.bodySmall,
                                color = if (correoCopia.isBlank()) Color.Gray else Color(0xFF4A148C),
                                fontWeight = if (correoCopia.isNotBlank()) FontWeight.Bold else FontWeight.Normal
                            )
                        }
                        Spacer(modifier = Modifier.height(4.dp))
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Icon(Icons.Filled.Edit, contentDescription = null, tint = Color(0xFF7B1FA2), modifier = Modifier.size(14.dp))
                            Spacer(modifier = Modifier.width(4.dp))
                            Text("Editar correos", style = MaterialTheme.typography.labelSmall, color = Color(0xFF7B1FA2))
                        }
                    }
                }
            }
        }

        if (isLoading) {
            Box(modifier = Modifier.fillMaxWidth().padding(40.dp), contentAlignment = Alignment.Center) {
                CircularProgressIndicator(color = SmartVanColors.CyanAccent)
            }
        } else if (solicitudes.isEmpty()) {
            Card(
                modifier = Modifier.fillMaxWidth(),
                colors = CardDefaults.cardColors(containerColor = Color(0xFFF5F5F5)),
                shape = RoundedCornerShape(14.dp)
            ) {
                Column(
                    modifier = Modifier.fillMaxWidth().padding(32.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Icon(Icons.Filled.Receipt, contentDescription = null, tint = Color.LightGray, modifier = Modifier.size(48.dp))
                    Spacer(modifier = Modifier.height(12.dp))
                    Text("No hay solicitudes de factura", fontWeight = FontWeight.Bold, color = Color.Gray)
                    Text("Cuando un cliente solicite factura al comprar, aparecerá aquí.", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                }
            }
        } else {
            // Aviso de solicitudes pendientes con más de 3 días sin atender
            val ahoraMs = org.example.abigail.obtenerMilisegundosActuales()
            val pendientesViejas = solicitudes.count { it.estatus == "pendiente" && it.timestamp > 0L && (ahoraMs - it.timestamp) > 259200000L }
            if (pendientesViejas > 0) {
                Card(
                    colors = CardDefaults.cardColors(containerColor = Color(0xFFFFF3E0)),
                    shape = RoundedCornerShape(12.dp),
                    modifier = Modifier.fillMaxWidth().padding(bottom = 12.dp)
                ) {
                    Row(modifier = Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Filled.Receipt, contentDescription = null, tint = SmartVanColors.Naranja, modifier = Modifier.size(18.dp))
                        Spacer(modifier = Modifier.width(8.dp))
                        Text("$pendientesViejas solicitud(es) pendiente(s) con más de 3 días — envíalas al contador.", style = MaterialTheme.typography.bodySmall, color = SmartVanColors.NaranjaDeep, fontWeight = FontWeight.Bold)
                    }
                }
            }

            // Filtro por estatus
            var filtroEstatus by remember { mutableStateOf("todos") }
            Row(modifier = Modifier.fillMaxWidth().padding(bottom = 12.dp), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                listOf("todos" to "Todos", "pendiente" to "Pendientes", "enviada" to "Enviadas", "facturada" to "Facturadas").forEach { (key, label) ->
                    FilterChip(
                        selected = filtroEstatus == key,
                        onClick = { filtroEstatus = key },
                        label = { Text(label, style = MaterialTheme.typography.labelSmall) },
                        colors = FilterChipDefaults.filterChipColors(
                            selectedContainerColor = Color(0xFFE0F7FA),
                            selectedLabelColor = SmartVanColors.AzulOscuro
                        )
                    )
                }
            }

            val filtradas = if (filtroEstatus == "todos") solicitudes else solicitudes.filter { it.estatus == filtroEstatus }

            LazyColumn(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                items(filtradas.size) { index ->
                    val sol = filtradas[index]
                    FacturaCard(solicitud = sol, viewModel = viewModel, correoContador = correoContador, correoCopia = correoCopia)
                }
            }
        }
    }
}

@Composable
fun FacturaCard(solicitud: SolicitudFactura, viewModel: AdminViewModel, correoContador: String, correoCopia: String = "") {
    val clipboardText = buildString {
        appendLine("📋 SOLICITUD DE FACTURA")
        appendLine("━━━━━━━━━━━━━━━━━")
        appendLine("RFC: ${solicitud.rfc}")
        appendLine("Razón Social: ${solicitud.razonSocial}")
        appendLine("Régimen Fiscal: ${solicitud.regimenFiscal}")
        appendLine("Uso CFDI: ${solicitud.usoCfdi}")
        appendLine("C.P. Fiscal: ${solicitud.cpFiscal}")
        appendLine("━━━━━━━━━━━━━━━━━")
        appendLine("Correo: ${solicitud.email}")
        appendLine("Monto: $${solicitud.monto} MXN")
        appendLine("Ruta: ${solicitud.ruta}")
        appendLine("Fecha: ${solicitud.fecha}")
        appendLine("Horario: ${solicitud.horario}")
        appendLine("Asientos: ${solicitud.asientos}")
    }

    val estatusColor = when (solicitud.estatus) {
        "pendiente" -> SmartVanColors.Naranja
        "enviada" -> Color(0xFF2196F3)
        "facturada" -> SmartVanColors.Verde
        else -> Color.Gray
    }
    val estatusLabel = when (solicitud.estatus) {
        "pendiente" -> "PENDIENTE"
        "enviada" -> "ENVIADA AL CONTADOR"
        "facturada" -> "FACTURADA"
        else -> solicitud.estatus.uppercase()
    }

    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(2.dp),
        shape = RoundedCornerShape(14.dp)
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            // Header con estatus
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                // weight + 2 líneas: razón social larga se envuelve sin empujar el chip de estatus fuera.
                Text(
                    solicitud.razonSocial.ifBlank { "Sin razón social" },
                    fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro,
                    style = MaterialTheme.typography.titleSmall,
                    maxLines = 2, overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.weight(1f)
                )
                Card(
                    colors = CardDefaults.cardColors(containerColor = estatusColor.copy(alpha = 0.15f)),
                    shape = RoundedCornerShape(6.dp)
                ) {
                    Text(estatusLabel, color = estatusColor, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.labelSmall, modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp))
                }
            }

            Spacer(modifier = Modifier.height(10.dp))

            // Datos fiscales
            Card(
                colors = CardDefaults.cardColors(containerColor = Color(0xFFF5F5F5)),
                shape = RoundedCornerShape(10.dp),
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(modifier = Modifier.padding(12.dp)) {
                    Text("DATOS FISCALES", style = MaterialTheme.typography.labelSmall, color = SmartVanColors.CyanAccent, fontWeight = FontWeight.Bold)
                    Spacer(modifier = Modifier.height(6.dp))
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                        Text("RFC:", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                        Text(solicitud.rfc, style = MaterialTheme.typography.bodySmall, fontWeight = FontWeight.Bold, color = SmartVanColors.AzulOscuro)
                    }
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                        Text("Régimen:", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                        Text(solicitud.regimenFiscal, style = MaterialTheme.typography.bodySmall, color = SmartVanColors.AzulOscuro)
                    }
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                        Text("Uso CFDI:", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                        Text(solicitud.usoCfdi, style = MaterialTheme.typography.bodySmall, color = SmartVanColors.AzulOscuro)
                    }
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                        Text("C.P. Fiscal:", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                        Text(solicitud.cpFiscal, style = MaterialTheme.typography.bodySmall, color = SmartVanColors.AzulOscuro)
                    }
                }
            }

            Spacer(modifier = Modifier.height(8.dp))

            // Info del viaje
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                Column {
                    Text("${solicitud.ruta} | ${solicitud.fecha}", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                    Text("${solicitud.horario} | Asientos: ${solicitud.asientos}", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                    Text("Correo: ${solicitud.email}", style = MaterialTheme.typography.bodySmall, color = Color.Gray)
                }
                Text("$${solicitud.monto} MXN", fontWeight = FontWeight.Black, color = SmartVanColors.Verde, style = MaterialTheme.typography.titleMedium)
            }

            Spacer(modifier = Modifier.height(12.dp))

            // Botones de acción
            val uriHandler = LocalUriHandler.current
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                // Botón compartir por WhatsApp
                OutlinedButton(
                    onClick = {
                        val encoded = clipboardText.replace(" ", "%20").replace("\n", "%0A")
                        uriHandler.openUri("https://wa.me/?text=$encoded")
                    },
                    modifier = Modifier.weight(1f),
                    border = BorderStroke(1.dp, Color(0xFF25D366)),
                    shape = RoundedCornerShape(10.dp)
                ) {
                    Icon(Icons.Filled.Phone, contentDescription = null, tint = Color(0xFF25D366), modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(4.dp))
                    Text("WhatsApp", color = Color(0xFF25D366), style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold)
                }

                // Botón enviar al contador por correo (SendGrid, server-side)
                Button(
                    onClick = { viewModel.enviarSolicitudAlContador(solicitud.id) },
                    modifier = Modifier.weight(1f).height(40.dp),
                    enabled = correoContador.isNotBlank(),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF7B1FA2)),
                    shape = RoundedCornerShape(10.dp)
                ) {
                    Icon(Icons.Filled.Email, contentDescription = null, tint = Color.White, modifier = Modifier.size(16.dp))
                    Spacer(modifier = Modifier.width(4.dp))
                    Text(if (correoContador.isNotBlank()) "Enviar al Contador" else "Configura correo", color = Color.White, style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold)
                }
            }

            // Botones de estatus
            if (solicitud.estatus == "enviada") {
                Spacer(modifier = Modifier.height(8.dp))
                Button(
                    onClick = { viewModel.marcarFacturaComoFacturada(solicitud.id) },
                    modifier = Modifier.fillMaxWidth().height(40.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = SmartVanColors.Verde),
                    shape = RoundedCornerShape(10.dp)
                ) {
                    Text("Marcar como Facturada", style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold, color = Color.White)
                }
            }
        }
    }
}
